$(function() {
  const free_shipping_threshold_eu = Math.round(41.27 * parseFloat(Shopify.currency.rate));
  const shipping_cost_eu = Math.round(238 * parseFloat(Shopify.currency.rate));
  const free_shipping_threshold_au = 100;
  const free_shipping_threshold_ca = 100;
  const shipping_cost_au = 9.00;
  const shipping_cost_ca = 8.00;
  const free_shipping_threshold_pl = 215; // Poland
  const shipping_cost_pl = 13.00;        // Poland

  /** Intercept fetch(/cart.js) so we can re-render when the cart changes */
  function catchRequest(url, callback) {
    var f = fetch;
    window.fetch = function() {
      const request = f.apply(window, arguments);
      if (arguments[0] === url) request.then(callback);
      return request;
    }
  }

  /**
   * Count qualifying items (pads) for the B2G1 banner.
   *  - Uses whitelist from Liquid when available (window.CW_B2G1_IDS)
   *  - Excludes any product with title containing "keyboard", "keycap", or "aviator cable"
   *  - Falls back to counting ALL items if whitelist is empty
   */
  function countPads(items) {
    const arr = (window.CW_B2G1_IDS || []).map(Number).filter(n => !Number.isNaN(n));
    const ids = new Set(arr);
    const excludedWords = /(keyboard|keycap|aviator cable)/i;

    const totalItems = (items || []).reduce((n, i) => {
      const title = (i.title || '').toLowerCase();
      if (excludedWords.test(title)) return n; // skip excluded items
      return n + Number(i.quantity || 0);
    }, 0);

    // If no whitelist, count all non-excluded items
    if (ids.size === 0) return totalItems;

    // Otherwise count only whitelisted and not excluded
    const whitelistedCount = (items || []).reduce((n, i) => {
      const title = (i.title || '').toLowerCase();
      if (excludedWords.test(title)) return n;
      const qualifies = ids.has(Number(i.product_id));
      return n + (qualifies ? Number(i.quantity || 0) : 0);
    }, 0);

    return whitelistedCount > 0 ? whitelistedCount : totalItems;
  }

  /** Render everything (accepts the whole cart so we can count items) */
  function renderElements(cart_value, cart) {
    $('.shipping-progress').hide();
    $('.free-shipping-badge').hide();
    $('.cw-cart-drawer-subtotals .discount-row').hide();

    if (['european-union', 'germany', 'france', 'spain', 'italy'].includes(cw_market_handle)) {
      if (cart_value < free_shipping_threshold_eu) {
        const money_left = free_shipping_threshold_eu - cart_value;
        const percent_left = (cart_value * 100) / free_shipping_threshold_eu;
        $('.shipping-progress').show();
        $('.shipping-progress .progress-bar').show();
        $('.shipping-progress .progress-bar-value').css('width', percent_left + '%');
        $('.shipping-progress span').html(CW_formatMoney(money_left * 100));
        $('.cw-cart-drawer-subtotals .discount-row.shipping-number').show();
        $('.cw-cart-drawer-subtotals .discount-row.shipping-number .value').text(CW_formatMoney(shipping_cost_eu));
      } else {
        $('.free-shipping-badge').show();
        $('.cw-cart-drawer-subtotals .discount-row.shipping-free').show();
      }
      $('.cw-cart-drawer-subtotals .discount-row.taxes-n-duties').show();

    } else if (['australia'].includes(cw_market_handle)) {
      if (cart_value < free_shipping_threshold_au) {
        const money_left = free_shipping_threshold_au - cart_value;
        const percent_left = (cart_value * 100) / free_shipping_threshold_au;
        $('.shipping-progress').show();
        $('.shipping-progress .progress-bar').show();
        $('.shipping-progress .progress-bar-value').css('width', percent_left + '%');
        $('.shipping-progress span').html(CW_formatMoney(money_left * 100));
        $('.cw-cart-drawer-subtotals .discount-row.shipping-number').show();
        $('.cw-cart-drawer-subtotals .discount-row.shipping-number .value').text(CW_formatMoney(shipping_cost_au * 100));
      } else {
        $('.free-shipping-badge').show();
        $('.cw-cart-drawer-subtotals .discount-row.shipping-free').show();
      }
      $('.cw-cart-drawer-subtotals .discount-row.taxes-n-duties').show();

    } else if (['canada'].includes(cw_market_handle)) {
      if (cart_value < free_shipping_threshold_ca) {
        const money_left = free_shipping_threshold_ca - cart_value;
        const percent_left = (cart_value * 100) / free_shipping_threshold_ca;
        $('.shipping-progress').show();
        $('.shipping-progress .progress-bar').show();
        $('.shipping-progress .progress-bar-value').css('width', percent_left + '%');
        $('.shipping-progress span').html(CW_formatMoney(money_left * 100));
        $('.cw-cart-drawer-subtotals .discount-row.shipping-number').show();
        $('.cw-cart-drawer-subtotals .discount-row.shipping-number .value').text(CW_formatMoney(shipping_cost_ca * 100));
      } else {
        $('.free-shipping-badge').show();
        $('.cw-cart-drawer-subtotals .discount-row.shipping-free').show();
      }

    } else if (['poland'].includes(cw_market_handle)) {
      const cart_value_pl = cart_value;
      if (cart_value_pl < free_shipping_threshold_pl) {
        const money_left = free_shipping_threshold_pl - cart_value_pl;
        const percent_left = (cart_value_pl * 100) / free_shipping_threshold_pl;
        $('.shipping-progress').show();
        $('.shipping-progress .progress-bar').show();
        $('.shipping-progress .progress-bar-value').css('width', percent_left + '%');
        $('.shipping-progress span').html(CW_formatMoney(money_left * 100));
        $('.cw-cart-drawer-subtotals .discount-row.shipping-number').show();
        $('.cw-cart-drawer-subtotals .discount-row.shipping-number .value').text(CW_formatMoney(shipping_cost_pl * 100));
      } else {
        $('.free-shipping-badge').show();
        $('.cw-cart-drawer-subtotals .discount-row.shipping-free').show();
      }
      $('.cw-cart-drawer-subtotals .discount-row.taxes-n-duties').show();

    } else if (['gb', 'united-states-2'].includes(cw_market_handle)) {
      // B2G1 banner for UK + US (united-states-2)
      const pads = countPads((cart && cart.items) || []);
      const $barWrap  = $('.shipping-progress');
      const $progress = $('.shipping-progress .progress-bar');
      const $fill     = $('.shipping-progress .progress-bar-value');

      // Keep the standard "Shipping: Free" row; never show the extra badge for this promo
      $('.cw-cart-drawer-subtotals .discount-row.shipping-free').show();
      if (cw_market_handle === 'united-states-2') {
        $('.cw-cart-drawer-subtotals .discount-row.taxes-n-duties').show();
      }
      $('.free-shipping-badge').hide();

      // Message area
      const $host = $('.shipping-progress > div:first');
      if (!$host.find('#uk-offer-text').length) $host.html('<span id="uk-offer-text"></span>');
      const $text = $('#uk-offer-text');

      if (pads <= 0) {
        $text.text('🔥 Add 2 Pads To Unlock A FREE Mousepad!');
        $barWrap.show(); $progress.show(); $fill.css('width','0%'); $barWrap.removeClass('is-success');
      } else if (pads === 1) {
        $text.text('🔥 Almost There — Add 1 More Pad To Unlock Your FREE Mousepad!');
        $barWrap.show(); $progress.show(); $fill.css('width','33%'); $barWrap.removeClass('is-success');
      } else if (pads === 2) {
        $text.text('🎉 Add Any 3rd Pad — It’s FREE On Us!');
        $barWrap.show(); $progress.show(); $fill.css('width','66%'); $barWrap.removeClass('is-success');
      } else {
        // Unlocked: show ONLY the success banner; hide the bar
        $text.text('🔥 You Scored a FREE Mousepad!');
        $barWrap.show();
        $progress.hide();
        $barWrap.addClass('is-success');
      }

      // Pulse animation each time we update the message
      $text.addClass('pulse');
      setTimeout(() => $text.removeClass('pulse'), 1500);

    } else {
      $('.cw-cart-drawer-subtotals .discount-row.shipping-calculated').show();
    }
  }

  /** helpers to format and feed data into render */
  function getCartValue(cart) {
    return parseFloat((cart.items_subtotal_price / 100.0).toFixed(2));
  }

  function refreshCart() {
    fetch('/cart.js').then(r => r.json()).then(cart => {
      renderElements(getCartValue(cart), cart);
    });
  }

  catchRequest('/cart.js', function(response) {
    response.clone().json().then(function(cart) {
      renderElements(getCartValue(cart), cart);
    });
    return response;
  });

  // initial render
  refreshCart();

  // Safety net: re-render after qty adjustments/removes in the drawer
  document.addEventListener('click', function(e) {
    if (
      e.target.closest('.ajaxcart__qty') ||
      e.target.closest('[data-update-quantity]') ||
      e.target.closest('[data-remove]') ||
      e.target.closest('.ajaxcart__qty-adjust')
    ) {
      setTimeout(refreshCart, 150);
    }
  });
  document.addEventListener('change', function(e) {
    if (e.target.closest('.ajaxcart__qty')) {
      setTimeout(refreshCart, 150);
    }
  });
});
